import React from "react"
import { ThemeProvider } from "@emotion/react"

import { Theme } from "components"

const ColorMode = ({ children, mode }) => {
  // Pick the mode's color overrides (e.g. "dark"), falling back to the base palette.
  const modeColors =
    (Theme.colors.modes && Theme.colors.modes[mode]) || Theme.colors

  return (
    <ThemeProvider
      theme={{ ...Theme, colors: { ...Theme.colors, ...modeColors } }}
    >
      {children}
    </ThemeProvider>
  )
}

export default ColorMode
